import { ListTerminDrawer } from '@/domain/termine/features/Calendar/List/Termin/ListTerminDrawer';
import { Termin } from '@/domain/termine/shared/types/Termin';

export function ListTerminEntry({
  termine,
  ...divProps
}: {
  termine: Termin[];
} & React.HTMLAttributes<HTMLDivElement>) {
  const handleContainerClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      className="flex flex-col w-full"
      onClick={handleContainerClick}
      {...divProps}>
      {termine.map((termin) => (
        <ListTerminDrawer key={termin.id} termin={termin} />
      ))}
    </div>
  );
}
